module.exports = __webpack_public_path__ + "static/media/Jeffri.3fbb4376.jpeg";